
export default function validateRequestNotes( value ) {
    if (value.includes("\t") || value.includes("\n") || value.includes("\r") || value.includes("'") || value.includes('"')) {
        return value.replace(/\t|\n|\r|['"]/g, '');
    }
    return value ;
}